<template>
    <nav :class="['top-nav-container', { 'scrolled': isScrolled }]">
      <div class="top-nav-content">
        <div class="nav-group">
          <router-link :to="`/${$i18n.locale}`" class="nav-brand">{{ $t('interface.ai_inspiration_hub') }}</router-link>
          <div class="nav-left">
            <router-link :to="`/${$i18n.locale}`" class="nav-link" exact>{{ $t('interface.nav.home') }}</router-link>
            <router-link :to="`/${$i18n.locale}/funding`" class="nav-link">{{ $t('interface.nav.funding') }}</router-link>
            <!-- <router-link to="/export-channels" class="nav-link">{{ $t('interface.nav.exportChannels') }}</router-link> -->
          </div>
        </div>
        <div class="nav-right">
          <SearchBox />
          <LanguageSwitcher class="header-lang" />
        </div>
      </div>
    </nav>
  </template>
  
  <script>
  import SearchBox from './SearchBox.vue';
  import LanguageSwitcher from './LanguageSwitcher.vue';

  export default {
    name: 'TopNav',
    components: {
      SearchBox,
      LanguageSwitcher
    },
    data() {
      return {
        isScrolled: false, // 控制导航条是否为半透明状态
      };
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll); // 监听滚动事件
    },
    beforeUnmount() { // 使用 beforeUnmount 替代 beforeDestroy
      window.removeEventListener('scroll', this.handleScroll); // 组件卸载时移除事件监听
    },
    methods: {
      handleScroll() {
        this.isScrolled = window.scrollY > 50; // 滚动超过50px时变为半透明
      },
    },
  };
  </script>
  
  <style scoped>
  /* 顶部导航容器 —— 墨黑底 + 发丝分割线（编辑风报头） */
  .top-nav-container {
    background-color: var(--ink, #1b1815);
    border-bottom: 1px solid var(--brass-rule, #e0d8c6);
    position: sticky;
    top: 0;
    z-index: 1000;
    transition: background-color 0.3s, border-color 0.3s;
  }

  /* 滚动时墨黑半透明 + 轻微毛玻璃，浮于内容之上 */
  .top-nav-container.scrolled {
    background-color: rgba(27, 24, 21, 0.92);
    -webkit-backdrop-filter: blur(6px);
    backdrop-filter: blur(6px);
    border-bottom-color: var(--brass-hairline, #cdbfa6);
  }

  /* 报头内容：品牌+导航 / 搜索 二段式
     容器宽度对齐页面正文（1300px / 95%），去掉额外水平内缩，
     使品牌与正文左缘齐平、搜索/语言贴近右缘，消除"两侧留白过多"的割裂感 */
  .top-nav-content {
    max-width: 1300px;
    width: 95%;
    margin: 0 auto;
    display: flex;
    align-items: center; /* 整体与搜索框垂直居中 */
    justify-content: space-between;
    gap: 1.5rem;
    padding: 0.625rem 0;
  }

  /* 品牌 + 导航按文字基线对齐，避免不同字体高度错位 */
  .nav-group {
    display: flex;
    align-items: baseline;
    gap: 2rem;
  }

  /* 品牌字标 —— 衬线体，报头气质，字号与导航更协调 */
  .nav-brand {
    font-family: var(--font-display, "Noto Serif SC", serif);
    font-size: 1.15rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: #f5f5f5;
    text-decoration: none;
    white-space: nowrap;
    flex-shrink: 0;
    line-height: 1;
  }

  .nav-left {
    display: flex;
    align-items: baseline;
    gap: 1.75rem;
  }

  /* 导航链接 —— 暖灰文字，无衬线体，克制字号 */
  .nav-link {
    color: #d4cfc8;
    font-size: 0.95rem;
    font-weight: 500;
    text-decoration: none;
    transition: color 0.3s, border-bottom 0.3s;
    padding: 0.25rem 0;
    font-family: var(--font-sans, -apple-system, system-ui, sans-serif);
    border-bottom: 2px solid transparent; /* 预留位避免跳动 */
    line-height: 1;
  }

  /* 悬停和激活 —— 黄铜下划线点缀 */
  .nav-link:hover,
  .nav-link.router-link-active {
    color: #f5f5f5;
    border-bottom: 2px solid var(--brass, #b39a6b);
  }

  /* 搜索区 */
  .nav-right {
    display: flex;
    align-items: center;
    gap: 0.85rem;
  }

  /* header 内语言切换与搜索框垂直居中对齐，间距与导航节奏一致 */
  .header-lang {
    margin: 0;
  }
  </style>